import React, { useEffect, useState } from "react";
import { Field, FormikProvider, Form, useFormik, ErrorMessage } from "formik";
import * as DESUI from "react-bootstrap";
import Menubar from "../Menubar";
import { store } from "../../App";
import ShowAlert from "../alert";
import MasterService from "../../Services/MasterService";
import SwaranandhraService from "../../Services/SwaranandhraService";
import { IoIosReturnLeft } from "react-icons/io";
import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import "jspdf-autotable";
import { Container, Button, Col, Row } from "reactstrap";
import { generatePdf ,exportToExcel} from "../utils/commonFunctions";
import { Link } from "@mui/material";


const BookGenartionStatus=({ placeholder = "" })=> {
  const [mainEnb, setMainEnb] = useState(false);
  const [search_Text, setsearch_Text] = useState("");
  const [District_data, setDistrict_data] = useState();

  const [distlist, setDistrictList] = useState([]);
  const [Districtenb, setDistrictenb] = useState(false);
  const [Mandal_data, setMandal_data] = useState();
  const [SubEnbmandal, setSubenbmandal] = useState(false);
  const [search_Text1, setsearch_Text1] = useState("");
  const [backenb, setbackenb] = useState(false);
  const [maindata, setmaindata] = useState([]);

  let username = localStorage.getItem("username");
  let roleid = localStorage.getItem("role");
  let district = localStorage.getItem("districtid");

  const formik = useFormik({
    initialValues: {
      district_id: "",
    },
  });

  React.useEffect(() => {
    if (roleid === "2" || roleid === "10" || roleid === "3") {
      setDistrictenb(true);
    }

    if (roleid === "5") {
      setDistrictenb(false);
    }
    formik.setFieldValue("district_id", district !== "0" ? district : "");

    
    
  }, []);

  useEffect(() => {
    MasterService.getDistricts().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.id}>
              {item.value}
            </option>
          );
        });
        setDistrictList(options);
      }
    });

    if (roleid === "2" || roleid === "10") {
      let params = {
        level: "MandalLevel",
        userId: username,
        district_id: district
      };
      store.dispatch({ type: "SHOW_SPINNER" });
      SwaranandhraService.getMndalVisionBookGeneratedStatusReport(params)
        .then((res) => {
          if (res.data && res.data.SCODE === "01") {
            setMandal_data(res.data.SDESC);
          }
          setMainEnb(false);
          setSubenbmandal(true);
        })
        .catch((err) => {
          ShowAlert(err, "error");
        })
        .finally(() => {
          store.dispatch({ type: "HIDE_SPINNER" });
        });
    }
  }, []);

  const Back = () => {
    setSubenbmandal(false);
    setMainEnb(true);
    setDistrict_data(maindata);
  };

  const Mandaldata = (detail) => {
    formik.setFieldValue("district_id", detail.district_code);
    setbackenb(true);
    let params = {
      userId: username,
      "level": "MandalLevel",
      district_id: detail.district_code,
    };
    store.dispatch({ type: "SHOW_SPINNER" });
    SwaranandhraService.getMndalVisionBookGeneratedStatusReport(params)
      .then((res) => {
        if (res.data && res.data.SCODE === "01") {
          setMandal_data(res.data.SDESC);
          setMainEnb(false);
          setSubenbmandal(true);

        }
      })
      .catch((err) => {
        ShowAlert(err, "error");
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };


  const Districtdata = (e) => {
    const districtId = e.target.value;
    formik.setFieldValue("district_id", districtId);

    if ((roleid === "5" || roleid === "8") && districtId !== "" && districtId !== undefined) {
      let params;

      if (districtId === "0") {
        params = {
          level: "All",
          userId: username
        };
      } else if (districtId !== "0") {
        params = {
          level: "DistrictLevel",
          userId: username,
          district_id: districtId
        };
      }
      store.dispatch({ type: "SHOW_SPINNER" });

      SwaranandhraService.getMndalVisionBookGeneratedStatusReport(params)
        .then((res) => {
          if (res.data && res.data.SCODE === "01") {
            setDistrict_data(res.data.SDESC);
            setmaindata(res.data.SDESC);
          }
          setMainEnb(true);
          setSubenbmandal(false);

        })
        .catch((err) => {
          ShowAlert(err, "error");
        })
        .finally(() => {
          store.dispatch({ type: "HIDE_SPINNER" });
        });
    }
  };

  const filterData = (dataa, search) =>
    search.length > 0
      ? dataa?.filter((item) =>
        Object.keys(item).some((key) => {
          const value = item[key];
          return (
            value !== null &&
            value.toString().toLowerCase().includes(search.toLowerCase())
          );
        })
      )
      : dataa;

  const filteredData = filterData(District_data, search_Text);
  const filteredData1 = filterData(Mandal_data, search_Text1);


  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "80%" }}>
        <div className="sa-title"> <h2> Mandal Vision Book <span>Generated Status Report</span> </h2> </div>
      </Container>

      <DESUI.Container fluid style={{ width: "80%" }} className="outer-page-content-container" >
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <div className="mandal-container p-4 mt-2">
              <Row>
                <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="mx-4 mandal-col" >
                  <label className="mb-1 fw-bold"> DISTRICT </label>{" "}
                  <span style={{ color: "red" }}> *</span>
                  <Field component="select" name="district_id" disabled={Districtenb} value={formik.values.district_id} className="form-control" onChange={(e) => { Districtdata(e); }} >
                    <option value="">--Select--</option>
                    <option value="0">All</option>
                    {distlist}
                  </Field>
                  <span style={{ color: "red", fontSize: "13px" }}>
                    {" "}
                    <ErrorMessage name="district_id" />{" "}
                  </span>
                </Col>
              </Row>
            </div>
          </Form>
        </FormikProvider>
        <br />

        {mainEnb && (
          <>
            <DESUI.Row>
              <DESUI.Col
                xs={12}
                sm={12}
                md={3}
                lg={3}
                xl={3}
                xxl={3}
                className="mb-3"
              >
                <div class="input-group">
                  <div className="input-group-prepend">
                    {" "}
                    <div
                      className="input-group-text group_txt11"
                      id="btnGroupAddon"
                    >
                      {" "}
                      <AiOutlineSearch />{" "}
                    </div>{" "}
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    onChange={(event) => setsearch_Text(event.target.value)}
                  />
                </div>
              </DESUI.Col>

              <DESUI.Col
                xs={12}
                sm={12}
                md={9}
                lg={9}
                xl={9}
                xxl={9}
                className=" mb-2 float-end"
              >
                <Button
                  variant="danger"
                  size="sm"
                  className="btn mx-2 pdf-btn"
                  onClick={() => generatePdf("#my-table", "Book Generation Status Report")}
                  style={{ float: "right", marginLeft: "3px" }}
                >
                  PDF
                  <MdOutlinePictureAsPdf />{" "}
                </Button>
                <Button
                  variant="success"
                  size="sm"
                  className="btn mx-2 excel-btn"
                  style={{ float: "right", color: "#ffffff", marginLeft: "3px" }}
                  onClick={() => exportToExcel("my-table", "Book Generation Status Report")}
                >
                  Excel<AiFillFileExcel style={{ fontSize: "18px" }} />
                </Button>
              </DESUI.Col>
            </DESUI.Row>
            <DESUI.Row>
              <DESUI.Col
                xs={12}
                sm={12}
                md={1}
                lg={1}
                xl={1}
                xxl={1}
              ></DESUI.Col>

              <DESUI.Col
                xs={12}
                sm={12}
                md={10}
                lg={10}
                xl={10}
                xxl={10}
              >
                <div id="table-scroll" className="table-scroll">
                  <div className="table-wrap">
                    <DESUI.Table
                      striped
                      bordered
                      hover
                      id="my-table"
                      className="table  custom-table table-responsive"
                    >
                      <thead>
                        <tr>
                          <th>Sl.No.</th>
                          <th>District</th>
                          <th style={{ width: "15%" }}>Book generated count</th>

                        </tr>
                      </thead>
                      <tbody>
                        {filteredData?.length === 0 ||
                          filteredData?.length === undefined ? (
                          <tr>
                            {" "}
                            <td
                              colSpan={3}
                              className="text-center"
                              style={{ color: "red" }}
                            >
                              Details Not Found
                            </td>{" "}
                          </tr>
                        ) : (
                          filteredData?.map((detail, i) => (
                            <tr key={i}>
                              <td style={{ textAlign: "center" }}>{i + 1}</td>
                              <td className="text-left">{detail.district_name}</td>

                              <td style={{ width: "15%" }} className="text-end">
                                <Link style={{ cursor: "pointer", color: "blue", textDecoration: "none", fontFamily: "sans-serif" }}
                                onClick={() => {
                                  if (detail.book_generated_count === 0) {
                                    ShowAlert("No data found", "warning");
                                  } else {
                                    Mandaldata(detail);
                                  }
                                }} >{detail.book_generated_count}</Link></td>





                            </tr>
                          ))
                        )}
                      </tbody>
                      {District_data.length > 1 ? (
                        <tfoot
                          style={{ position: "sticky", bottom: "0px" }}
                          className="text-right"
                        >
                          <tr className="table_countshead">
                            <td
                              colSpan={2}
                              className="text-center"
                              style={{ fontWeight: "bold" }}
                            >
                              Totals
                            </td>
                            <td className="text-end" style={{ fontWeight: "bold" }}>
                              {District_data?.reduce(
                                (total, detail) =>
                                  total +
                                  (isNaN(detail.book_generated_count)
                                    ? 0
                                    : detail.book_generated_count ?? 0),
                                0
                              )}
                            </td>

                          </tr>
                        </tfoot>
                      ) : null}
                    </DESUI.Table>
                  </div>
                </div>
              </DESUI.Col>
              <DESUI.Col
                xs={12}
                sm={12}
                md={1}
                lg={1}
                xl={1}
                xxl={1}
              ></DESUI.Col>
            </DESUI.Row>
          </>
        )}

        {SubEnbmandal && (
          <>
            <DESUI.Row>
              <DESUI.Col
                xs={12}
                sm={12}
                md={3}
                lg={3}
                xl={3}
                xxl={3}
                className=" mb-2"
                style={{ marginLeft: "40px" }}
              >
                <div class="input-group">
                  <div className="input-group-prepend">
                    {" "}
                    <div
                      className="input-group-text group_txt11"
                      id="btnGroupAddon"
                    >
                      {" "}
                      <AiOutlineSearch />{" "}
                    </div>{" "}
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    onChange={(event) => setsearch_Text1(event.target.value)}
                  />
                </div>
              </DESUI.Col>

              <DESUI.Col
                xs={12}
                sm={12}
                md={4}
                lg={4}
                xl={4}
                xxl={4}
                className=" mb-2 float-center"
              >
                <Button
                  variant="danger"
                  size="sm"
                  className="btn mx-2 pdf-btn"
                  onClick={() => generatePdf("#my-table1", "Book Generation Status Report")}
                  style={{ float: "right", marginLeft: "3px" }}
                >
                  PDF
                  <MdOutlinePictureAsPdf />{" "}
                </Button>
                <Button
                  variant="success"
                  size="sm"
                  className="btn mx-2 excel-btn"
                  style={{ float: "right", color: "#ffffff", marginLeft: "3px" }}
                  onClick={() => exportToExcel("my-table1", "Book Generation Status Report")}
                >
                  Excel<AiFillFileExcel style={{ fontSize: "18px" }} />
                </Button>
              </DESUI.Col>
              <DESUI.Col
                xs={12}
                sm={12}
                md={4}
                lg={4}
                xl={4}
                xxl={4}
                className=" mb-2 float-end"
              >
                {backenb && <Button
                  variant="warning"
                  className="btn btn-sm warn-btn"
                  onClick={Back}
                  style={{ float: "right", marginLeft: "3px" }}
                >
                  <IoIosReturnLeft /> BACK
                </Button>}
              </DESUI.Col>
            </DESUI.Row>
            <div
              id="table-scroll"
              className="table-scroll"
              style={{ width: "72%" }}
            >
              <div className="table-wrap">
                <DESUI.Table
                  bordered
                  hover
                  id="my-table1"
                  className="table custom-table table-responsive"
                >
                  <thead>
                    <tr>
                      <th colSpan={3}></th>
                    </tr>
                    <tr className="text-center">
                      <th>Sl.No.</th>

                      <th>Mandal Name</th>
                      <th>Book Generated Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData1?.length === 0 ||
                      filteredData1?.length === undefined ? (
                      <tr>
                        {" "}
                        <td
                          colSpan={3}
                          className="text-center"
                          style={{ color: "red" }}
                        >
                          Details Not Found
                        </td>{" "}
                      </tr>
                    ) : (
                      filteredData1?.map((detail, i) => (
                        <tr key={i}>
                          <td style={{ textAlign: "center" }}>{i + 1}</td>
                          <td className="text-left"> {detail.mandal_name} </td>
                          <td className="text-right">{detail.book_generated_count}</td>

                        </tr>
                      ))
                    )}
                  </tbody>
                
                  {filteredData1.length > 0  && (
                        <tfoot
                          style={{ position: "sticky", bottom: "0px" }}
                          className="text-right"
                        >
                          <tr className="table_countshead">
                            <td
                              colSpan={2}
                              className="text-center"
                              style={{ fontWeight: "bold" }}
                            >
                              Totals
                            </td>
                            <td className="text-end" style={{ fontWeight: "bold" }}>
                              {filteredData1?.reduce(
                                (total, detail) =>
                                  total +
                                  (isNaN(detail.book_generated_count)
                                    ? 0
                                    : detail.book_generated_count ?? 0),
                                0
                              )}
                            </td>

                          </tr>
                        </tfoot>
                      ) }
                </DESUI.Table>
              </div>
            </div>
          </>
        )}
      </DESUI.Container>
    </>
  );
};
export default BookGenartionStatus;
